import reducers from "./reducers";

const localReducers = {
  selectedEvent: reducers.selectedEventReducer,
  currenctUser: reducers.currentUserReducer,
};

export { localReducers };
